/**
 * @module app.kya.list.kyaListCtrl
 *
 * The let names witch contain "loading" mean : is a request pending ?
 */
define(['angular', 'moment'], function(angular, moment) {


    function KyaListCtrl(
        $scope,
        $window,
        $location,
        $timeout,
        $log,
        $filter,
        $rootScope,
        Notification,
        $uibModal,
        userNetworkService,
        userService,
        commonService,
        kyaFiltersService,
        contractService,
        editionService,
        agentService,
        authService
    ) {
        authService.updateLoginStatus(); // on verifie que le token est toujours là
        // $scope.selectActiveMenu(4);
        let self = {};
        self.commonService = commonService;
        self.userService = userService;
        self.contracts = [];
        self.loadingContracts = true;
        self.isOtherContractsLoading = false;
        self.isOtherContracts = true;
        self.partners = [];
        self.markets = [];
        self.networks = [];

        /**
         * Update contract list
         * @param {Boolean} append
         */
        function _updateContractsList(append) {
            self.loadingContracts = true;
            contractService
                .getContracts(_filters)
                .then(function(res) {
                    if (append) {
                        self.contracts = self.contracts.concat(res);
                    }
                    else {
                        self.contracts = res;
                    }
                    if (res.length < _filters.limit) {
                        self.isOtherContracts = true;
                    }
                })
                .catch(function(err) {
                    $log.error(err);
                    self.contracts = [];
                })
                .finally(function() {
                    self.isOtherContractsLoading = false;
                    self.loadingContracts = false;
                });
        }

        /**
         * Load more contracts
         */
        self.loadMoreContracts = function() {
            self.isOtherContractsLoading = true;
            _filters.offset++;
            _updateContractsList(true);
        };

        self.getClassLabel = function(str) {
            let classLabel;
            switch (str) {
                case 'TABAC':
                    classLabel = 'info';
                    break;
                case 'PRESSE':
                    classLabel = 'info';
                    break;
                case 'TABAC PRESSE':
                    classLabel = 'info';
                    break;
                case 'GROUPE FEUILLETTE':
                case 'BOULANGERIE':
                    classLabel = 'warning';
                    break;
                case 'FLEURISTE TRAD':
                case 'FLEURISTE FLORAJET':
                case 'FLEURISTE FLORAJET BY SHOP APP':
                case 'FLEURISTE':
                    classLabel = 'florajet';
                    break;
                case 'NAP':
                    classLabel = 'nap';
                    break;
                default:
                    classLabel = 'trad';
            }
            return classLabel;
        };

        /**
         * Get the contract's creator lastname and firstname to display
         * If the uid is not found into the people array, it returns the uid instead of the name
         * @param  {String} uid
         * @return {String}
         */
        self.getName = function(uid) {
            const user = userService.findPerson(uid);
            return user ? user.user.displayName : uid;
        };

        self.selectAnAgent = function(id) {
            self.loadingContracts = true;
            return agentService
                .getAnAgent(id)
                .then(function(store) {
                    $rootScope.store = store[0];
                })
                .then(function() {
                    $location.path('kya/contracts/');
                });
        };

        self.reedit = function(contract) {
            $window.open(
                editionService.url + 'edition/template/' + contract.storeId + '/' + contract.templateXsl,
                '_blank'
            );
        };

        /**
         * Prepare the contract to delete
         * @param  {int} id
         */
        self.prepareDelete = function(id) {
            self.contractToDelete = id;
            _openModalDeleteContract();
        };

        /**
         * Delete the prepared contract
         */
        function _confirmDelete() {
            let index = 0;
            for (let i = 0; i < self.contracts.length; i++) {
                if (self.contracts[i].id === self.contractToDelete) {
                    index = i;
                    contractService
                        .deleteContract(self.contracts[i])
                        .then(function(info) {
                            Notification.success(info.message);

                            // Delete the contract in the displayed list
                            self.contracts.splice(index, 1);
                        })
                        .catch(function(err) {
                            Notification.error(err.data);
                            $log.error(err);
                        });
                }
            }
        }

        /**
         * Prepare the contract to send
         * @param  {int} id
         */
        self.prepareSend = function(id) {
            self.contractToSend = id;
            _openModalSendContract();
        };

        /**
         *
         * Send the prepared contract
         * @param  {Object} data object coming from sendContract modal
         */
        function _confirmSend(data) {
            for (let i = 0; i < self.contracts.length; i++) {
                if (self.contracts[i].id === self.contractToSend) {
                    self.contracts[i].dateSend = moment(data.dateSend, 'DD/MM/YYYY').format('YYYY-MM-DD');
                    self.contracts[i].isSend = 1;
                    contractService
                        .sendContract(self.contracts[i])
                        .then(function(info) {
                            Notification.success(info.message);
                        })
                        .catch(function(err) {
                            Notification.error('Une erreur est survenue: ' + err.data);
                            $log.error(err);
                        });
                    break;
                }
            }
        }

        /**
         * Prepare the contract to cancel
         * @param  {int} id
         */
        self.prepareCancel = function(id) {
            self.contractToCancel = id;
            _openModalCancelContract();
        };

        /**
         *
         * Cancel the prepared contract
         * @param  {Object} data object coming from sendContract modal
         */
        function _confirmCancel(data) {
            for (let i = 0; i < self.contracts.length; i++) {
                if (self.contracts[i].id === self.contractToCancel) {
                    self.contracts[i].dateCancellation = new Date(moment().format('YYYY-MM-DD'));
                    self.contracts[i].isCancelled = 1;
                    contractService
                        .cancelContract(self.contracts[i])
                        .then(function(info) {
                            Notification.success(info.message);
                        })
                        .catch(function(err) {
                            Notification.error('Une erreur est survenue: ' + err.data);
                            $log.error(err);
                        });
                    break;
                }
            }
        }

        /**
         * Prepare the contrat to sign
         * @param  {int} id
         */
        self.prepareSign = function(id) {
            self.contractToSign = id;
            _openModalSignContract();
        };

        /**
         *
         * Sign the contract
         * @param  {Object} data object coming from signContract modal
         */
        function _confirmSign(data) {
            for (var i = 0; i < self.contracts.length; i++) {
                if (self.contracts[i].id === self.contractToSign) {
                    self.contracts[i].isSigned = 1;
                    self.contracts[i].dateSignature = moment(data.dateSignature, 'DD/MM/YYYY').format('YYYY-MM-DD');
                    self.contracts[i].signBy = self.userNetwork.user.uid;

                    contractService
                        .signContract(self.contracts[i])
                        .then(function(info) {
                            Notification.success(info.message);
                        })
                        .catch(function(err) {
                            Notification.error('une erreur est survenue: ' + err.data);
                            $log.error(err);
                        });
                    break;
                }
            }
        }

        /**
         * Save the comment
         * @param {Object} contract
         */
        self.saveComment = function(contract) {
            contractService
                .saveComment(contract)
                .then(function(res) {
                    Notification.success(res.message);
                })
                .catch(function(res) {
                    Notification.error(
                        'Une erreur est survenue ' + (res.data && res.data.message ? ': ' + res.data.message : '')
                    );
                    $log.error(res);
                });
        };

        self.isClickable = function(contract) {
            return contract.id !== null && !contract.isCancelled;
        };

        /* =========================================================================================== */
        /*                                        FILTERS                                              */
        /* =========================================================================================== */

        let _filters = {
            rds: [],
            drv: [],
            partner: [],
            telepro: [],
            cup: [],
            csd: [],
            formerRDS: [],
            market: [],
            network: [],
            offset: 0,
            limit: 50
        };

        _initIHMFilters();

        self.isFiltered = false;

        /* Date updated filter */
        self.dateStartFilterOptions = kyaFiltersService.dateUpdatedOptions;
        self.dateEndFilterOptions = kyaFiltersService.dateUpdatedOptions;

        self.isOpenedDateStartFilter = false;
        self.isOpenedDateEndFilter = false;
        self.isOpenedCreationDateStartFilter = false;
        self.isOpenedCreationDateEndFilter = false;

        self.toggleDateStartFilter = function() {
            self.isOpenedDateStartFilter = kyaFiltersService.toggle(self.isOpenedDateStartFilter);
        };

        self.toggleDateEndFilter = function() {
            self.isOpenedDateEndFilter = kyaFiltersService.toggle(self.isOpenedDateEndFilter);
        };

        self.toggleCreationDateStartFilter = function() {
            self.isOpenedCreationDateStartFilter = kyaFiltersService.toggle(self.isOpenedCreationDateStartFilter);
        };

        self.toggleCreationDateEndFilter = function() {
            self.isOpenedCreationDateEndFilter = kyaFiltersService.toggle(self.isOpenedCreationDateEndFilter);
        };

        /* Month of signature filter */
        self.signatureMonthFilterOptions = kyaFiltersService.signatureMonthOptions;
        self.isOpenedSignatureMonthFilter = [false, false];

        self.toggleSignatureMonthFilter = function(index) {
            self.isOpenedSignatureMonthFilter[index] = kyaFiltersService.toggle(
                self.isOpenedSignatureMonthFilter[index]
            );
        };

        /**
         * Generate the values for the rds filter at the clear or loading action
         * @return {Array}
         */
        function _generateRDSFilter() {
            if (self.userNetwork.user.role === 'DRV') {
                _filters.drv = [self.userNetwork.user.uid];
                return [];
            }
            if (!self.userNetwork.drv.length && self.userNetwork.rds.length) {
                let rds = [];
                for (let i = 0; i < self.userNetwork.rds.length; i++) {
                    rds.push(self.userNetwork.rds[i].user.uid);
                }
                return rds;
            }
            return !self.userNetwork.rds.length ? [self.userNetwork.user.uid] : [];
        }

        /**
         * Generate the values for the csd filter at the clear or loading action
         * @return {Array}
         */
        function _generateCSDFilter() {
            if (self.userNetwork.csd.length) {
                let csd = [];
                for (let i = 0; i < self.userNetwork.csd.length; i++) {
                    csd.push(self.userNetwork.csd[i].user.uid);
                }
                return csd;
            }
            return !self.userNetwork.csd.length ? [self.userNetwork.user.uid] : [];
        }

        /**
         * Apply selected filter values
         */
        self.applyFilter = function() {
            if (!self.isFiltered) {
                _filters.offset = 0;
                self.isOtherContracts = true;
            }

            if (
                self.identifiantFilter !== null &&
                self.identifiantFilter !== '' &&
                !Number.isInteger(parseInt(self.identifiantFilter))
            ) {
                Notification.error("<b>Erreur sur l'identifiant:</b> ce n'est pas un nombre");
                return;
            }
            if (
                self.updateDateEndFilter !== null &&
                commonService.checkDateRange(self.updateDateStartFilter, self.updateDateEndFilter) === false
            ) {
                Notification.error(
                    '<b>Erreur sur la période du filtre:</b> date de modification de début avant celle de fin'
                );
                return;
            }
            if (
                self.creationDateEndFilter !== null &&
                commonService.checkDateRange(self.creationDateStartFilter, self.creationDateEndFilter) === false
            ) {
                Notification.error(
                    '<b>Erreur sur la période du filtre:</b> date de création de début avant celle de fin'
                );
                return;
            }
            if (
                self.signatureMonthFilter[1] !== null &&
                commonService.checkDateRange(self.signatureMonthFilter[0], self.signatureMonthFilter[1]) === false
            ) {
                Notification.error(
                    '<b>Erreur sur la période du filtre:</b> Mois de signature de début avant celui de fin'
                );
                return;
            }

            // Map present filters in the controller to build an array with their values
            let filtersToSave = kyaFiltersService.filtersList.map(function(key) {
                return self[key];
            });
            console.log(filtersToSave);
            // Save builts array with filters values
            kyaFiltersService.saveKyaFilters(filtersToSave);

            _filters.updateDateStart = kyaFiltersService.applyFullDateFilter(self.updateDateStartFilter);
            _filters.updateDateEnd = kyaFiltersService.applyFullDateFilter(self.updateDateEndFilter);
            _filters.creationDateStart = kyaFiltersService.applyFullDateFilter(self.creationDateStartFilter);
            _filters.creationDateEnd = kyaFiltersService.applyFullDateFilter(self.creationDateEndFilter);
            _filters.signatureMonth = self.signatureMonthFilter.map(kyaFiltersService.applyMonthDateFilter);

            _updateContractsList(false);
        };

        /**
         * Reset filters
         */
        self.clearFilters = function() {
            kyaFiltersService.clearFilters();

            _initIHMFilters();

            _filters.rds = _generateRDSFilter();
            _filters.drv = [];
            _filters.partner = [];
            _filters.telepro = [];
            _filters.cup = [];
            _filters.csd = [];
            _filters.formerRDS = [];
            _filters.market = [];
            _filters.network = [];
            _filters.offset = 0;
            _initFiltersValues();

            let partnerFilterLength = self.partnerFilter.length;
            for (let i = 0; i < partnerFilterLength; i++) {
                self.partnerFilter[i] = false;
            }

            let marketFilterLength = self.marketFilter.length;
            for (let i = 0; i < marketFilterLength; i++) {
                self.marketFilter[i] = false;
            }

            let networkFilterLength = self.networkFilter.length;
            for (let i = 0; i < networkFilterLength; i++) {
                self.networkFilter[i] = false;
            }

            self.isOtherContracts = true;

            self.userNetwork.rds.forEach(function(rds) {
                rds.checked = false;
            });

            self.userNetwork.drv.forEach(function(drv) {
                drv.checked = false;
            });

            self.userNetwork.telepro.forEach(function(telepro) {
                telepro.checked = false;
            });

            self.userNetwork.csd.forEach(function(csd) {
                csd.checked = csd.user.uid === $rootScope.user.uid;
            });

            self.userNetwork.cup.forEach(function(cup) {
                cup.checked = false;
            });

            self.userNetwork.formerRDS.forEach(function(formerRDS) {
                formerRDS.checked = false;
            });

            self.rdsFilter = _generateRDSFilterForIHM();
            self.updateCSDFilter();

            _updateContractsList(false);
        };

        /**
         * Generate the RDS filter options list
         * @param  {Array} parents
         * @return {Array}
         */
        function _generateRDSFilterForIHM(parents) {
            if (!parents || !parents.length) {
                return self.userNetwork.rds;
            }

            let rds = [];
            for (let i = 0; i < parents.length; i++) {
                for (let j = 0; j < self.userNetwork.rds.length; j++) {
                    if (parents[i].user.uid === self.userNetwork.rds[j].parent) {
                        rds.push(self.userNetwork.rds[j]);
                    }
                }
            }
            return rds;
        }

        /* WATCHERS SECTION: On filters arrays to construct values for the request and uncheck same filter's checkboxes */

        $scope.$watchCollection('kyaListCtrl.signedFilter', function(newValue, oldValue) {
            if (oldValue.length === 0) {
                return;
            }
            _filters.signed = kyaFiltersService.applyFilter(self.signedFilter, 'signed');

            if (!oldValue[0] && newValue[0]) {
                self.signedFilter = [true, false];
                self.cancelledFilter = [false, false];
                self.sendFilter = [false, false];
            }

            if (!oldValue[1] && newValue[1]) {
                self.signedFilter = [false, true];
                self.cancelledFilter = [false, false];
                self.sendFilter = [false, false];
            }
        });

        $scope.$watchCollection('kyaListCtrl.cancelledFilter', function(newValue, oldValue) {
            if (oldValue.length === 0) {
                return;
            }
            _filters.cancelled = kyaFiltersService.applyFilter(self.cancelledFilter, 'cancelled');

            if (!oldValue[0] && newValue[0]) {
                self.cancelledFilter = [true, false];
                self.signedFilter = [false, false];
                self.sendFilter = [false, false];
            }

            if (!oldValue[1] && newValue[1]) {
                self.cancelledFilter = [false, true];
                self.signedFilter = [false, false];
                self.sendFilter = [false, false];
            }
        });

        $scope.$watchCollection('kyaListCtrl.sendFilter', function(newValue, oldValue) {
            if (oldValue.length === 0) {
                return;
            }
            _filters.send = kyaFiltersService.applyFilter(self.sendFilter, 'send');

            if (!oldValue[0] && newValue[0]) {
                self.signedFilter = [false, false];
                self.cancelledFilter = [false, false];
                self.sendFilter = [true, false];
            }

            if (!oldValue[1] && newValue[1]) {
                self.signedFilter = [false, false];
                self.cancelledFilter = [false, false];
                self.sendFilter = [false, true];
            }
        });

        $scope.$watchCollection('kyaListCtrl.jdsInjectedFilter', function(newValue, oldValue) {
            if (oldValue.length === 0) {
                return;
            }
            _filters.jdsInjected = kyaFiltersService.applyFilter(self.jdsInjectedFilter, 'jdsInjected');

            if (!oldValue[0] && newValue[0]) {
                self.jdsInjectedFilter = [true, false];
            }

            if (!oldValue[1] && newValue[1]) {
                self.jdsInjectedFilter = [false, true];
            }
        });

        $scope.$watchCollection('kyaListCtrl.stateFilter', function(newValue, oldValue) {
            if (oldValue.length === 0) {
                return;
            }
            _filters.state = kyaFiltersService.applyFilter(self.stateFilter, 'state');

            if (!oldValue[0] && newValue[0]) {
                self.stateFilter = [true, false];
            }

            if (!oldValue[1] && newValue[1]) {
                self.stateFilter = [false, true];
            }
        });

        $scope.$watch('kyaListCtrl.agentFilter', function(newValue, oldValue) {
            if (oldValue === '') {
                return;
            }
            _filters.agent = null;

            if (newValue !== '') {
                _filters.agent = newValue;
            }
        });

        $scope.$watch('kyaListCtrl.identifiantFilter', function(newValue, oldValue) {
            if (oldValue === '') {
                return;
            }
            _filters.identifiant = null;

            if (newValue !== '') {
                _filters.identifiant = newValue;
            }
        });

        function _generateArrayFilterForIHM(array) {
            return kyaFiltersService.getDefaultFilter('boolean', array.length);
        }

        /**
         * Watch drv filter input to construct filter value
         */
        self.updateDRVFilter = function() {
            let selectedDRV = $filter('filter')(self.userNetwork.drv, { checked: true });
            _filters.drv = [];
            let parents = [];

            for (let i = 0; i < selectedDRV.length; i++) {
                _filters.drv.push(selectedDRV[i].user.uid);
                parents.push(selectedDRV[i]);
            }

            self.rdsFilter = _generateRDSFilterForIHM(parents);
        };

        self.updateTeleproFilter = function() {
            let selectedTelepro = $filter('filter')(self.userNetwork.telepro, { checked: true });
            _filters.telepro = [];

            for (let i = 0; i < selectedTelepro.length; i++) {
                _filters.telepro.push(selectedTelepro[i].user.uid);
            }
        };

        self.updateCSDFilter = function() {
            let selectedCsd = $filter('filter')(self.userNetwork.csd, { checked: true });
            _filters.csd = [];

            for (let i = 0; i < selectedCsd.length; i++) {
                _filters.csd.push(selectedCsd[i].user.uid);
            }
        };

        self.updateCUPFilter = function() {
            let selectedCup = $filter('filter')(self.userNetwork.cup, { checked: true });
            _filters.cup = [];

            for (let i = 0; i < selectedCup.length; i++) {
                _filters.cup.push(selectedCup[i].user.uid);
            }
        };

        self.updateFormerRDSFilter = function() {
            let selectedRDS = $filter('filter')(self.userNetwork.formerRDS, { checked: true });
            _filters.formerRDS = [];

            for (let i = 0; i < selectedRDS.length; i++) {
                _filters.formerRDS.push(selectedRDS[i].user.uid);
            }
        };

        /**
         * Watch rds filter input to construct filter value
         */
        self.updateRDSFilter = function() {
            let selectedRDS = $filter('filter')(self.userNetwork.rds, { checked: true });
            _filters.rds = [];

            for (let i = 0; i < selectedRDS.length; i++) {
                _filters.rds.push(selectedRDS[i].user.uid);
            }
        };

        /**
         *  update filters.partners with id from marketsList according to checked filters
         */
        function _updatePartnerFilter() {
            let partnerCodes = self.partners.map(function(partner) {
                // get code
                return partner.code;
            });
            _filters.partner = kyaFiltersService.applyMultipleFilterValues(self.partnerFilter, partnerCodes);
        }
        self.updatePartnerFilter = _updatePartnerFilter;

        function _updateNetworkFilter() {
            let networkCodes = self.networks.map(function(network) {
                // get code
                return network.store_type;
            });
            _filters.network = kyaFiltersService.applyMultipleFilterValues(self.networkFilter, networkCodes);
        }
        self.updateNetworkFilter = _updateNetworkFilter;

        /**
         *  update filters.partners with id from marketsList according to checked filters
         */
        function _updateMarketFilter() {
            let marketCodes = self.markets.map(function(market) {
                // get code
                return market.store_activity;
            });
            _filters.market = kyaFiltersService.applyMultipleFilterValues(self.marketFilter, marketCodes);
        }
        self.updateMarketFilter = _updateMarketFilter;

        /**
         * Apply default filters Values to IHM
         */
        function _initIHMFilters() {
            if (kyaFiltersService.saved) {
                kyaFiltersService.filtersList.forEach(function(key, index) {
                    self[key] = kyaFiltersService.getFilters()[index]; // assign saved filter values
                });
            }
            else {
                self.signedFilter = kyaFiltersService.getDefaultFilter('boolean', 2);
                self.cancelledFilter = kyaFiltersService.getDefaultFilter('boolean', 2);
                self.sendFilter = kyaFiltersService.getDefaultFilter('boolean', 2);
                self.jdsInjectedFilter = kyaFiltersService.getDefaultFilter('boolean', 2);
                self.stateFilter = kyaFiltersService.getDefaultFilter('boolean', 2);
                self.identifiantFilter = kyaFiltersService.getDefaultFilter('integer');
                self.agentFilter = kyaFiltersService.getDefaultFilter('string');
                self.updateDateStartFilter = kyaFiltersService.getDefaultFilter('date');
                self.updateDateEndFilter = kyaFiltersService.getDefaultFilter('date');
                self.creationDateStartFilter = kyaFiltersService.getDefaultFilter('date');
                self.creationDateEndFilter = kyaFiltersService.getDefaultFilter('date');
                self.signatureMonthFilter = kyaFiltersService.getDefaultFilter('dateInterval', 2);
            }
        }

        function _initFiltersValues() {
            _filters.identifiant = self.identifiantFilter;
            _filters.signed = kyaFiltersService.applyFilter(self.signedFilter, 'signed');
            _filters.cancelled = kyaFiltersService.applyFilter(self.cancelledFilter, 'cancelled');
            _filters.send = kyaFiltersService.applyFilter(self.sendFilter, 'send');
            _filters.updateDateStart = kyaFiltersService.applyFullDateFilter(self.updateDateStartFilter);
            _filters.updateDateEnd = kyaFiltersService.applyFullDateFilter(self.updateDateEndFilter);
            _filters.creationDateStart = kyaFiltersService.applyFullDateFilter(self.creationDateStartFilter);
            _filters.creationDateEnd = kyaFiltersService.applyFullDateFilter(self.creationDateEndFilter);
            _filters.signatureMonth = self.signatureMonthFilter.map(kyaFiltersService.applyMonthDateFilter);
            _filters.agent = self.agentFilter;
            _filters.jdsInjected = kyaFiltersService.applyFilter(self.jdsInjectedFilter, 'jdsInjected');
            _filters.state = kyaFiltersService.applyFilter(self.stateFilter, 'state');
        }

        /* =========================================================================================== */
        /*                                         JDS                                                 */
        /* =========================================================================================== */

        self.jdsLoading = false;

        /**
         * Set the contract isJdsInjected attribute to
         * @method setJdsInjected
         * @param  {Object} contract
         * @param  {Boolean} value isJdsInjected value
         */
        self.setJdsInjected = function(contract, value) {
            contract.isJdsInjected = value;
            contractService
                .setJdsInjected(contract, value)
                .then(function(res) {
                    Notification.success(res.message);
                })
                .catch(function(res) {
                    Notification.error(
                        'Une erreur est survenue ' + (res.data && res.data.message ? ': ' + res.data.message : '')
                    );
                    $log.error(res);
                });
        };

        /**
         * Open JDS report with specific contracts
         * @return {Promise} promise returned from contractService.getContracts
         */
        self.loadJds = function(partner) {
            self.jdsLoading = true;
            $rootScope.isUpsJds = false;

            // Set date filters values
            _filters.updateDateStart = kyaFiltersService.applyFullDateFilter(self.updateDateStartFilter);
            _filters.updateDateEnd = kyaFiltersService.applyFullDateFilter(self.updateDateEndFilter);
            _filters.creationDateStart = kyaFiltersService.applyFullDateFilter(self.creationDateStartFilter);
            _filters.creationDateEnd = kyaFiltersService.applyFullDateFilter(self.creationDateEndFilter);
            _filters.signatureMonth = self.signatureMonthFilter.map(kyaFiltersService.applyMonthDateFilter);

            if (partner !== undefined && partner === 'UPS') {
                _filters.partner = ['UPS'];
                $rootScope.isUpsJds = true;
            }

            return contractService.getContracts(kyaFiltersService.getJdsFilters(_filters)).then(function(contracts) {
                self.jdsLoading = false;
                if (!$rootScope.isUpsJds) {
                    contracts = contracts.filter(contract => contract.partner !== 'UPS');
                }
                $rootScope.contractsJds = contracts;
                $location.path('kya/jds/');
            });
        };

        /* =========================================================================================== */
        /*                                         MODALS                                              */
        /* =========================================================================================== */

        /**
         * Open the search client modal
         * @param  {String} size
         */
        self.openModal = function(size) {
            let _searchAgentModal = $uibModal.open({
                animation: true,
                templateUrl: 'searchAgentModal.html',
                controller: 'ChooseAgentCtrl',
                controllerAs: 'chooseAgentCtrl',
                size: size,
                resolve: {}
            });

            _searchAgentModal.result.then(function(res) {
                $rootScope.store = res.store;
                $location.path('kya/contracts/');
            });
        };

        /**
         * Open the delete order modal
         * @param  {String} size
         */
        function _openModalDeleteContract(size) {
            var deleteContractModal = $uibModal.open({
                animation: true,
                templateUrl: 'deleteContractModal.html',
                controller: 'DeleteContractCtrl',
                controllerAs: 'deleteContractCtrl',
                size: size,
                resolve: {}
            });

            deleteContractModal.result.then(function(isConfirm) {
                if (isConfirm) {
                    _confirmDelete();
                }
            });
        }

        /**
         * Open the send contract modal
         * @param  {String} size
         */
        function _openModalSendContract(size) {
            let _sendContractModal = $uibModal.open({
                animation: true,
                templateUrl: 'sendContract.html',
                controller: 'SendContractCtrl',
                controllerAs: 'sendContractCtrl',
                size: size,
                resolve: {
                    contract: function() {
                        return $rootScope.contract;
                    }
                }
            });
            _sendContractModal.result.then(function(data) {
                _confirmSend(data);
            });
        }

        /**
         * Open the cancel modal
         */
        function _openModalCancelContract(contract) {
            let _cancelContractModal = $uibModal.open({
                animation: true,
                templateUrl: 'cancelContractModal.html',
                controller: 'CancelContractCtrl',
                controllerAs: 'cancelContractCtrl',
                size: null,
                resolve: {
                    contract: function() {
                        return contract;
                    }
                }
            });

            _cancelContractModal.result.then(function(data) {
                _confirmCancel(data);
            });
        }

        /**
         * Open the sign contract modal
         * @param  {String} size
         */
        function _openModalSignContract(size) {
            var _signContractModal = $uibModal.open({
                animation: true,
                templateUrl: 'signContractModal.html',
                controller: 'SignContractCtrl',
                controllerAs: 'signContractCtrl',
                size: size,
                resolve: {
                    contract: function() {
                        return $rootScope.contract;
                    }
                }
            });

            _signContractModal.result.then(function(data) {
                _confirmSign(data);
            });
        }

        /* =========================================================================================== */
        /*                                         INIT                                                */
        /* =========================================================================================== */
        /**
         * Init the contract list
         * 1) Get the user network
         * 2) Init the filters
         * 3) Get the contracts
         */
        function _init() {
            self.userNetwork = $rootScope.userNetwork;
            self.isExt = userService.isExternalUser($rootScope.user);
            _filters.rds = _generateRDSFilter();
            self.rdsFilter = _generateRDSFilterForIHM();
            // _filters.csd     = _generateCSDFilter();
            if (self.userNetwork.rds && self.userNetwork.rds.length) {
                self.rdsFilter = self.userNetwork.rds;
            }
            if (self.userNetwork.telepro && self.userNetwork.telepro.length) {
                self.teleproFilter = self.userNetwork.telepro;
            }
            if (self.userNetwork.drv && self.userNetwork.drv.length) {
                self.drvFilter = self.userNetwork.drv;
            }
            if (self.userNetwork.csd && self.userNetwork.csd.length) {
                self.userNetwork.csd.map(t => t.checked = t.user.uid === $rootScope.user.uid);
                self.csdFilter = self.userNetwork.csd;
            }
            if (self.userNetwork.cup && self.userNetwork.cup.length) {
                self.cupFilter = self.userNetwork.cup;
            }
            if (self.userNetwork.formerRDS && self.userNetwork.formerRDS.length) {
                self.formerRDSFilter = self.userNetwork.formerRDS;
            }
            $rootScope.contract = contractService.getContractObject();
            // Init contract to create
            $rootScope.contract.initiateBy = self.userNetwork.user.uid;
            editionService.getAllPartners('kya').then(res => (self.partners = res));
            self.partnerFilter = _generateArrayFilterForIHM(self.partners);
            agentService.getDistinctActivities().then(res => (self.markets = res));
            self.marketFilter = _generateArrayFilterForIHM(self.markets);
            agentService.getDistinctTypes().then(res => (self.networks = res));
            self.networkFilter = _generateArrayFilterForIHM(self.networks);
            self.updateCSDFilter();
            _updatePartnerFilter();
            _updateMarketFilter();
            _updateNetworkFilter();
            _initFiltersValues();

            self.loadingContracts = true;
            return contractService.getContracts(_filters)
            .then(function(contracts) {
                self.contracts = contracts;
                if (contracts.length < _filters.limit) {
                    self.isOtherContracts = false;
                }
            })
            .catch(function(err) {
                $log.error(err);
                self.userNetwork = null;
                self.contracts = [];
            })
            .finally(function() {
                self.loadingContracts = false;
            });
        }

        _init();

        return self;
    }

    KyaListCtrl.$inject = [
        '$scope',
        '$window',
        '$location',
        '$timeout',
        '$log',
        '$filter',
        '$rootScope',
        'Notification',
        '$uibModal',
        'userNetworkService',
        'userService',
        'commonService',
        'kyaFiltersService',
        'contractService',
        'editionService',
        'agentService',
        'authService'
    ];

    angular
        .module('app.kya.list.kyaListCtrl', ['ui.bootstrap', 'ui-notification'])
        .controller('KyaListCtrl', KyaListCtrl);
});
